import { render, staticRenderFns } from "./PuzzleSelectOptionModal.vue?vue&type=template&id=64ea4cfc&scoped=true&"
import script from "./PuzzleSelectOptionModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleSelectOptionModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleSelectOptionModal.vue?vue&type=style&index=0&id=64ea4cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea4cfc",
  null
  
)

export default component.exports